import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './i18n';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { setupGlobalErrorHandler } from './services/errorLogger';
import { captureAttribution } from './services/attribution';

// Configurer le handler global d'erreurs
setupGlobalErrorHandler();

// Avant le rendu : le routeur peut réécrire l'URL et faire perdre les UTM.
captureAttribution();

// Ajout d'un log pour le débogage
// Log seulement en développement
if (process.env.REACT_APP_ENV === 'development') {
  console.log('React app starting...');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
